export const updateLimit = (page, currentLimit) => {
  return (dispatch, getState) => {
    dispatch({
      type: "SET_PAGE_LIMIT",
      page,
      currentLimit: parseInt(currentLimit),
    });
  };
};
